
import { Injectable } from '@angular/core';
import { EventBus } from '@mwp/event-bus';

type AppName = 'host' | 'moniecrm' | 'payments' | 'growth' | 'settings' | 'profileSetup' | 'facetec' | 'marketerOnboarding' | 'partnerOnboarding' | string & Record<never, never>;
type EventName = string;
export type EventKey = `${AppName}:${EventName}`;

@Injectable({
    providedIn: 'root',
})
export class EventBusService {
    private eventBus: EventBus<EventKey>;

    constructor() {
        this.eventBus = new EventBus();
    }

    getInstance() {
        return this.eventBus;
    }
}
